export const content = {
  title: "Brand Equity",
  subtitle:
    "See the impact that the strength of your brand in market is having on your baseline sales of product.",
};
